module.exports = __webpack_public_path__ + "assets/img/img134.571235c7.png";